import { useState } from 'react'
import {
  Box,
  Checkbox,
  CheckboxGroup,
  CheckboxGroupProps,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  StackProps,
  useColorModeValue as mode,
} from '@chakra-ui/react'
import { FiSearch } from 'react-icons/fi'

type CheckboxFilterProps = Omit<CheckboxGroupProps, 'onChange'> & {
  hideLabel?: boolean
  options: Array<{ label: string; value: string; count?: number }>
  label?: string
  onChange?: (value: string[]) => void
  spacing?: StackProps['spacing']
  showSearch?: boolean
}

export const CheckboxFilter = (props: CheckboxFilterProps) => {
  const { options, label, hideLabel, spacing = '2', showSearch, ...rest } = props
  const [searchQuery, setSearchQuery] = useState('')

  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchQuery.toLowerCase())
  )

  return (
    <Stack as="fieldset" spacing={spacing}>
      {!hideLabel && (
        <FormLabel fontWeight="semibold" as="legend" mb="0">
          {label}
        </FormLabel>
      )}
      {showSearch && (
        <InputGroup size="md" pb="1">
          <Input
            placeholder="Search..."
            rounded="md"
            focusBorderColor={mode('blue.500', 'blue.200')}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <InputRightElement pointerEvents="none" color="gray.400" fontSize="lg">
            <FiSearch />
          </InputRightElement>
        </InputGroup>
      )}
      <Box maxH="400px" overflowY="auto">
        <CheckboxGroup {...rest}>
          <Stack p={1} spacing={spacing}>
            {filteredOptions.map((option) => (
              <Checkbox key={option.value} value={option.value} colorScheme="blue" whiteSpace="nowrap">
                <span>{option.label}</span>
                {option.count != null && (
                  <Box as="span" ml="1" color="gray.500" fontSize="sm">
                    ({option.count})
                  </Box>
                )}
              </Checkbox>
            ))}
          </Stack>
        </CheckboxGroup>
      </Box>
    </Stack>
  )
}
